import BuyXGetY from '@/models/buyXGetY';
import {BuyXGetYProps} from '@/interfaces/models/buyXGetY';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((promotionProps: BuyXGetYProps[]): BuyXGetY[] => {
      return promotionProps.map(BuyXGetY.createFromRequest);
    });
  }
};
